<div class="well-explorer-cmp">
  <p-card>
    @if (user?.profile?.organization === 'Altus') {
      <div style="text-align: center" class="text-xs">
        <label style="text-decoration: underline;">Database: {{ user?.profile?.database.slice(0, -2) }}</label>
      </div>
    }

    <ng-template #header>
      <app-well-explorer-header
        [isAdmin]="userRoles?.admin"
        (closeSidenav)="handleCloseSidenav()"
        (companyAdded)="handleAddCompany($event)"
        (designUpdated)="nodeSelect($event)"
        (refreshWellExplorerEvent)="refreshWellExplorer($event, true)"
        [design]="design"
        [recentDesignSelection]="recentDesignSelection"
        [allDesigns]="allDesigns"
        [isGlobalAdmin]="user?.profile?.isGlobalAdmin"
      />
    </ng-template>

    <p-treeTable
      #treeTable
      dataKey="id"
      [autoLayout]="false"
      [scrollable]="true"
      [scrollHeight]="scrollHeight()"
      [columns]="cols"
      contextMenuSelectionMode="joint"
      selectionMode="single"
      [(selection)]="selectedNode"
      [loading]="loading()"
      (onNodeSelect)="nodeSelect($event)"
      [(contextMenuSelection)]="selectedNode"
      [value]="treeItems"
    >
    <ng-template #body let-rowNode let-rowData="rowData">
      <tr (contextmenu)="onRightClick($event)" [ngClass]="{ 'selected-node': selectedNode === rowNode.node }">
        
      <app-well-explorer-item
        [selectedDesignId]="selectedDesignId"
        [treeItems]="treeItems"
        [treeNode]="rowNode"
        [columns]="cols"
        [rowData]="rowData"
        [ttContextMenuRow]="rowNode"
        [selectedNode]="selectedNode"
        [isAdmin]="userRoles?.admin"
        [isGlobalAdmin]="user.profile?.isGlobalAdmin"
        (childNodeAdded)="handleAddChildNode($event)"
        (designCloned)="handleCloneDesign($event)"
        (openDesignInNewTab)="handleOpenDesignInNewTab($event)"
        (nodeSelected)="nodeSelect($event)"
        (nodeDeleted)="handleDeleteNode($event)"
        (itemRenamed)="handleRenameItem($event)"
        (designExported)="handleExportDesign($event)"
        (designMoved)="handleShowMoveDesignDialog($event)"
        (projectMoved)="handleShowMoveProjectDialog($event)"
        (siteMoved)="handleShowMoveSiteDialog($event)"
        (wellMoved)="handleShowMoveWellDialog($event)"
        (wellboreMoved)="handleShowMoveWellboreDialog($event)"
        (contextMenuUpdated)="handleContextMenuUpdated($event)"
        (importDesignDialogShow)="handleShowImportDesignDialog($event)"
      />
    </ng-template>
  </p-treeTable>
</p-card>

<p-contextMenu #cm [model]="contextMenuItems" appendTo="body"></p-contextMenu>

</div>